import React, { useState, useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";
import Accordion from "../Common/Accordion";
import {
  ServicesSection,
  ServicesHeader,
  CenteredTitle,
  ServicesContent,
  ServicesImage
} from "./ServicesStyles";

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" }
  }
};

const fadeInLeft = {
  hidden: { opacity: 0, x: -30 },
  visible: { 
    opacity: 1, 
    x: 0,
    transition: { duration: 0.6, ease: "easeOut" }
  }
};

const fadeInRight = {
  hidden: { opacity: 0, x: 30 },
  visible: { 
    opacity: 1, 
    x: 0,
    transition: { duration: 0.6, ease: "easeOut" }
  }
};

export default function Services() {
  const [activeAccordion, setActiveAccordion] = useState(null);
  const servicesRef = useRef(null);
  const servicesControls = useAnimation();
  const servicesInView = useInView(servicesRef, { once: true });

  React.useEffect(() => {
    if (servicesInView) servicesControls.start("visible");
  }, [servicesInView, servicesControls]);

  const services = [
    {
      title: "Programme and Project Management​",
      description: "Over 30 years' experience to guide and lead your business to optimise your project vision (goals and objectives) and support you in the delivery of your complete project life cycle."
    },
    {
      title: "Business Consultancy​",
      description: "Providing you with expert analysis and strategic process improvement as well as guide your business through the digital age using morden tools and strategies"
    },
    {
      title: "Change and Transformation Management​",
      description: "Helping your business prepare, generate momentum, and get ready for your business transformation "
    },
    {
      title: "Workspaces",
      description: "Providing you with an environment to create, enhance, and reinvigorate your ideas and vision"
    }
  ];

  return (
    <ServicesSection ref={servicesRef}>
      <ServicesHeader>
        <motion.div
          initial="hidden"
          animate={servicesControls}
          variants={fadeInUp}
        >
          <h2>Services</h2>
          <CenteredTitle>Reliable expertise to drive your greatest success</CenteredTitle>
        </motion.div>
      </ServicesHeader>

      <ServicesContent>
        <motion.div
          initial="hidden"
          animate={servicesControls}
          variants={fadeInLeft}
        >
          <ServicesImage>
            <img src="/services_pic.jpg" alt="Smiling Man" />
          </ServicesImage>
        </motion.div>

        <motion.div
          initial="hidden"
          animate={servicesControls}
          variants={fadeInRight}
        >
          <Accordion 
            items={services} 
            activeIndex={activeAccordion}
            onToggle={setActiveAccordion}
          />
        </motion.div>
      </ServicesContent>
    </ServicesSection>
  );
}